import * as UsageStatsListAction from './action';
const initialState = {
    divisionList: [],
    divisionListError: [],
    divisionListOptions:[],
    userList: [],
    userListError: [],
    userListOptions:[]
}

const UsageStatsListReducer = (state = initialState, action) => {
    switch (action.type) {
        case UsageStatsListAction.LIST_DIVISION_SUCCESS:
            let constructDivisionArray=[];
            action.data.forEach(element => {
                constructDivisionArray.push({value:element.id,label:element.corporateName})
            });
            return state = {
                ...state,
                divisionList: action.data,
                divisionListOptions:constructDivisionArray
            }
        case UsageStatsListAction.LIST_DIVISION_FAILURE:
            return state = {
                ...state,
                divisionListError: action.error
            }
        case UsageStatsListAction.LIST_USER_SUCCESS:
            let constructUserArray=[];
            action.data.forEach(element => {
                constructUserArray.push({value:element.userId,label:element.userName})
            });
            return state = {
                ...state,
                userList: action.data,
                userListOptions:constructUserArray
            }
        case UsageStatsListAction.LIST_USER_FAILURE:
            return state = {
                ...state,
                userListError: action.error
            }
            default: return state;
        }
    };

export default UsageStatsListReducer;
